import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapePolylineIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="shapePolyline" ref={ref} {...props}>
    <path d="M4,20.75a.64.64,0,0,1-.33-.08.73.73,0,0,1-.34-1l4-8A.75.75,0,0,1,8,11.25h7.54l3.79-7.58a.76.76,0,0,1,1-.34.75.75,0,0,1,.33,1l-4,8a.76.76,0,0,1-.67.41H8.46L4.67,20.34A.75.75,0,0,1,4,20.75Z" />
  </Icon>
)) as IconWithRender;

ShapePolylineIcon.displayName = 'ShapePolylineIcon';
ShapePolylineIcon.renderIcon = (props) => <ShapePolylineIcon {...props} />;
export default ShapePolylineIcon;
